<template>
  <div :style="cssVars">
    <page-layout
      :noSideBar="false"
      :headerBackgroundColor="cssVars['--outcome-primary']"
    >
      <template v-slot:headerContent>
        <div class="row items-center">
          <span
            :style="`color: ${cssVars['--outcome-secondary']}`"
            class="title"
          >
            {{
              currentUserData.sustainabilityBusiness_name
                ? currentUserData.sustainabilityBusiness_name
                : "Test Business"
            }}
          </span>
        </div>
        <div class="row items-center" style="position: relative">
          <span class="headerText text-white">
            {{
              selectedOutcome
                ? "Story Assessment Tool for"
                : "You need to select an outcome first"
            }}
          </span>
          <sustainability-dropdown
            :model="outcome"
            class="q-ml-sm"
            :style="`width: 230px;
                      background-color: ${
                        selectedOutcome
                          ? cssVars['--outcome-secondary']
                          : 'rgba(0,0, 0, 0.3)'
                      };
                      border-radius: 5px;
                      `"
            :options="outcomesList"
            :isObjects="true"
            objectKey="label"
            disable
          ></sustainability-dropdown>
          <span class="headerText text-white q-mx-sm">
            {{ selectedOutcome ? "Up to the end of" : "" }}
          </span>
          <year-picker
            ref="yearPicker"
            label=""
            :bg="cssVars['--outcome-secondary']"
            @selectYear="selectYear"
          ></year-picker>
          <q-img
            v-if="selectedOutcome"
            class="float-right"
            :src="getWhiteOutcomeImage(selectedOutcome)"
            style="position: absolute; right: 15px; width: 69px; top: -20px"
          ></q-img>
        </div>
      </template>
      <template v-slot:content>
        <div class="column q-pa-sm">
          <div class="col-auto" style="height: calc(100vh - 242px)">
            <q-scroll-area
              style="height: calc(100vh - 242px)"
              :thumb-style="{
                background: '#162c479c',
                opacity: 1,
                width: '8px',
                height: '8px',
                borderRadius: '20px',
              }"
            >
              <div class="row wrap">
                <div
                  class="q-pa-xs"
                  v-for="(storyCard, index) in storyCards"
                  :key="`storyCards_${index}`"
                  @click="selectedStoryCard = storyCard"
                >
                  <storyCard :flat="false" :greyBG="true" :data="storyCard" />
                </div>
              </div>
            </q-scroll-area>
          </div>
          <div class="col q-px-sm q-pt-sm">
            <q-btn
              class="q-px-sm q-py-xs bg-secondary"
              label="Back to Story Tool Editor"
              text-color="white"
              no-caps
              flat
              @click="goToStoryBoard"
            >
            </q-btn>
          </div>
        </div>
      </template>
      <template v-slot:sideBarContent>
        <!-- Wrapping only one DOM element, defined by QBtn -->
        <div class="column full-height full-width sidebar">
          <div
            class="col-auto q-my-none q-py-md q-px-md"
            style="height: calc(109px)"
          >
            <div class="row full-height items-center">
              <h3>Highlighted Story</h3>
            </div>
          </div>

          <div
            class="col-auto q-px-md"
            style="height: calc(100vh - 226px) !important"
          >
            <q-scroll-area
              style="height: calc(100vh - 226px) !important"
              :thumb-style="{
                background: '#162c479c',
                opacity: 1,
                width: '8px',
                height: '8px',
                borderRadius: '20px',
              }"
            >
              <div v-if="selectedStoryCard">
                <q-img
                  v-if="selectedStoryCard"
                  :src="
                    selectedStoryCard.imgUrl
                      ? selectedStoryCard.imgUrl
                      : 'https://upstreamnz.s3.ap-southeast-2.amazonaws.com/Sustainability+Plans/oatas_default.png'
                  "
                ></q-img>
                <h4 class="q-mt-sm q-mb-none" v-if="selectedStoryCard">
                  {{ selectedStoryCard.title }}
                </h4>
                <div
                  class="col-12 q-py-sm"
                  v-if="selectedStoryCard && selectedStoryCard.completed_at"
                >
                  {{
                    selectedStoryCard.completed_at | momentFormatMonthDayYear
                  }}
                </div>
                <div
                  class="col-12 q-py-sm"
                  v-if="selectedStoryCard && selectedStoryCard.description"
                >
                  {{ selectedStoryCard.description }}
                </div>
              </div>
              <div v-else>
                This is a summary of your <b class="highlight">Stories</b> for
                this outcome. <br />
                <br />
                Click on a story to reveal the full context
              </div>
            </q-scroll-area>
          </div>
          <div class="col-auto">
            <q-btn
              @click="goToAssessmentToolEditor"
              no-caps
              flat
              class="text-white bg-accent q-px-sm q-py-xs q-mx-sm float-right"
            >
              <span class="text-white text"> Complete Another Tool </span>
            </q-btn>
            <!-- <div class="col-6">
              <q-btn
                label="Review Summary"
                no-caps
                flat
                class="text-white full-height float-right q-my-xs q-mx-sm"
                :style="`background: ${cssVars['--outcome-secondary']}`"
                @click="goToStorySummary()"
              >
              </q-btn>
            </div> -->
          </div>
        </div>
      </template>
    </page-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageLayout from "@/components/pageLayout/pageLayout.vue";
import SustainabilityDropdown from "@/components/sustainabilityDropdown/sustainabilityDropdown.vue";
import { getCSSVars } from "@/functions/cssVars";
import YearPicker from "@/components/generalComponents/yearPicker.vue";
import storyCard from "@/components/storyCards/storyCard.vue";
import { getWhiteOutcomeImage } from "@/functions/getWhiteOutcomeImage";

export default {
  components: {
    PageLayout,
    SustainabilityDropdown,
    YearPicker,
    storyCard,
  },
  computed: {
    ...mapGetters({
      outcomesList: "outcomes/list",
      currentUserData: "auth/currentUserData",
      selectedOutcome: "businessOutcomePlans/selectedOutcome",
      storyCards: "storyCard/list",
      storyCardsLoading: "storyCard/listLoading",
    }),
    cssVars() {
      let outcome = this.selectedOutcome;
      return getCSSVars(outcome);
    },
  },
  data: () => ({
    outcome: null,
    selectedYear: null,
    selectedStoryCard: null,
  }),
  watch: {
    selectedOutcome: function () {
      this.initSelectedOutcome();
    },
    storyCards() {
      this.init();
    },
    $route: {
      handler() {
        this.handleRoute();
      },
      props: true,
    },
  },
  async mounted() {
    if (this.selectedOutcome) {
      this.initSelectedOutcome();
    }
    this.selectedYear = this.$moment().format("YYYY");
    this.loadData();
    this.init();
  },
  methods: {
    getWhiteOutcomeImage: getWhiteOutcomeImage,

    getCSSVars: getCSSVars,
    init() {
      if (this.$route.params.storyCard_id) {
        let storyCard = this.storyCards.find(
          (sc) => sc.id == this.$route.params.storyCard_id
        );
        if (storyCard) {
          this.selectedStoryCard = storyCard;
        }
      }
    },
    initSelectedOutcome() {
      this.outcome = this.selectedOutcome;
    },
    loadData() {
      this.$store.dispatch("storyCard/loadAll", {
        outcome_id: this.$route.params.outcomesID,
        year: this.selectedYear,
      });
    },
    selectYear(val) {
      this.selectedYear = val.split("/")[0];
      this.loadData();
    },
    goToStoryBoard() {
      this.$router.push(
        `${this.$route.path.split("storySummary")[0]}storyBoard`
      );
    },
    goToAssessmentToolEditor() {
      this.$router.push(
        `${this.$route.path.split("storySummary")[0]}chooseAssessmentTool`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  h3 {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 1.3rem;
    line-height: 29px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    color: $accent2;
    margin: 10px 0px;
  }

  h4 {
    font-size: 1rem;
    font-weight: 600;
    color: $accent;
    line-height: 1.1rem;
  }
}

.headerText {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
}

.storyCard {
  min-height: 342px;
  min-width: 260px;
  max-height: 342px;
  max-width: 260px;
  cursor: pointer;
  transition: box-shadow 250ms;

  &:hover {
    box-shadow: 0px 0px 15px 0px #c4c4c4 !important;
  }
}
</style>
